import { createSlice } from '@reduxjs/toolkit';
import { COMPANIES } from '../namespace';

const companiesSlice = createSlice({
  name: COMPANIES,
  initialState: {},
  reducers: {
    update: {
      reducer: (state, { payload: { company } }) => {
        state[company.id] = { ...state[company.id], ...company };
      },
      prepare: (company) => ({ payload: { company } }),
    },
  },
});

export const { update: updateCompany } = companiesSlice.actions;

export default { [COMPANIES]: companiesSlice.reducer };
